import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect } from "react";
import { Field, Formik } from 'formik';
import { Container, Row, Col } from 'react-bootstrap';
import Wrapper from '../../wrapper/Wrapper';
import { FormInput, FormControlledInput, FormSelect, StateBootstrapButton as StateButton } from '../../forms/elements';
import { formikEnhancer } from "./formik/formikEnhancer";
import { connect, ReactReduxContext } from 'react-redux'; // Redux

import { accountDuck } from "../../../ducks/account";
var accountOperations = accountDuck.operations;
export var RetailGuestForm = function RetailGuestForm(props) {
  var _props$setFieldTouche = props.setFieldTouched,
      setFieldTouched = _props$setFieldTouche === void 0 ? function () {
    return console.log("setFieldTouched");
  } : _props$setFieldTouche,
      _props$handleSubmit = props.handleSubmit,
      handleSubmit = _props$handleSubmit === void 0 ? function () {
    return console.log("handleSubmit");
  } : _props$handleSubmit,
      _props$errors = props.errors,
      errors = _props$errors === void 0 ? {} : _props$errors,
      _props$values = props.values,
      values = _props$values === void 0 ? {} : _props$values,
      stateLoading = props.stateLoading,
      _props$resetButtonSta = props.resetButtonState,
      resetButtonState = _props$resetButtonSta === void 0 ? function () {
    return "";
  } : _props$resetButtonSta;
  useEffect(function () {
    resetButtonState();
  }, []);

  var _onClick = function onClick() {
    setFieldTouched("number", true);
    setFieldTouched("verificationValue", true);

    if (!Object.keys(errors).length) {
      handleSubmit(values, {
        props: props
      });
    }
  };

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h2", {
    className: "cb-type__title"
  }, "Order Status"), /*#__PURE__*/React.createElement(OrderStatusField, _extends({
    label: "Order Number",
    name: "number"
  }, props)), /*#__PURE__*/React.createElement("h3", {
    className: "cb-type__title"
  }, "Verify With"), /*#__PURE__*/React.createElement(OrderStatusDropdown, props), /*#__PURE__*/React.createElement(OrderStatusField, _extends({
    label: "Verification",
    name: "verificationValue"
  }, props)), /*#__PURE__*/React.createElement(StateButton, {
    type: "submit",
    className: "cb-button-primary",
    onClick: function onClick() {
      return _onClick();
    },
    loading: stateLoading,
    onSubmit: handleSubmit
  }, "Submit")))));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$account;

  return {
    stateLoading: (_state$account = state.account) === null || _state$account === void 0 ? void 0 : _state$account.guestOrderLoad
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    postGuestOrderCheck: function postGuestOrderCheck(orderObj) {
      return dispatch(accountOperations.guestOrderCheck(orderObj));
    },
    resetButtonState: function resetButtonState() {
      return dispatch(accountOperations.errorGuestOrder());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(formikEnhancer(RetailGuestForm));
export var OrderStatusField = function OrderStatusField(_ref) {
  var label = _ref.label,
      name = _ref.name,
      changeHandler = _ref.changeHandler,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Field, {
    name: name,
    label: label // value={values.cvv}
    ,
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: changeHandler
  }));
};

var OrderStatusDropdown = function OrderStatusDropdown(_ref2) {
  var _ref2$values = _ref2.values,
      values = _ref2$values === void 0 ? {} : _ref2$values,
      _ref2$setFieldValue = _ref2.setFieldValue,
      setFieldValue = _ref2$setFieldValue === void 0 ? function () {
    return "";
  } : _ref2$setFieldValue;
  useEffect(function () {
    setFieldValue("verificationType", "zipCode");
  }, [setFieldValue]);
  return /*#__PURE__*/React.createElement(Field, {
    value: values.verification,
    name: "verificationType",
    label: "Verification",
    hideLabel: true,
    component: FormSelect,
    options: [{
      "label": "Billing Zip Code",
      "value": "zipCode"
    }, {
      "label": "Billing Phone Number",
      "value": "phoneNumber"
    }, {
      "label": "Billing Email",
      "value": "email"
    }],
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      console.log('Set e: ', e);
      setFieldValue("verificationType", e.currentTarget.value);
    }
  });
};